// extracted by mini-css-extract-plugin
export default {"root":"InfoBarItem_root__6VDJ-","image":"InfoBarItem_image__RHUex","title":"InfoBarItem_title__4Uvzv","value":"InfoBarItem_value__-DT+X"};